module.exports = __webpack_public_path__ + "static/media/shipment-package.7b45c300.svg";